import { render, staticRenderFns } from "./AppPreviewStep.vue?vue&type=template&id=d974a580&scoped=true&"
import script from "./AppPreviewStep.vue?vue&type=script&lang=js&"
export * from "./AppPreviewStep.vue?vue&type=script&lang=js&"
import style0 from "./AppPreviewStep.vue?vue&type=style&index=0&id=d974a580&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d974a580",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VIcon,VRow})
